module.exports = __webpack_public_path__ + "img/explain.1593f9b9.svg";